import * as SecureStore from 'expo-secure-store';
import { Platform } from 'react-native';

const AUTH_ENTRY_SEEN_KEY = 'perdiem.auth-entry-seen';

function getWebStorage() {
  if (Platform.OS !== 'web' || typeof localStorage === 'undefined') return null;
  if (typeof localStorage.getItem !== 'function') return null;
  if (typeof localStorage.setItem !== 'function') return null;
  return localStorage;
}

export async function hasSeenAuthEntry(): Promise<boolean> {
  if (Platform.OS === 'web') {
    return getWebStorage()?.getItem(AUTH_ENTRY_SEEN_KEY) === '1';
  }

  return (await SecureStore.getItemAsync(AUTH_ENTRY_SEEN_KEY)) === '1';
}

export async function markAuthEntrySeen(): Promise<void> {
  try {
    if (Platform.OS === 'web') {
      getWebStorage()?.setItem(AUTH_ENTRY_SEEN_KEY, '1');
      return;
    }

    await SecureStore.setItemAsync(AUTH_ENTRY_SEEN_KEY, '1');
  } catch {
    // This marker is a UX hint; auth cleanup and sign-out must still proceed.
  }
}
